export const GET_PARTS_SUCCESS = 'GET_PARTS_SUCCESS';
export const GET_MECHANIC_SUCCESS = 'GET_MECHANIC_SUCCESS';
